import cx from 'classnames';
import Panel from 'mk2/components/Panel';
import React from 'react';
import styles from './ClearableInput.mscss';

interface OwnProps {
    className?: string;
    hasValue?: boolean;
    icon?: React.ReactNode;
    clearIcon?: string;
    onClear?(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

const ClearableInput: React.FunctionComponent<Props> = ({
    className,
    hasValue = false,
    icon,
    children,
    onClear,
    clearIcon = 'fa-times',
}) => (
    <Panel className={cx(styles.ClearableInput, className)}>
        {icon && <div className={styles.ClearableInput__icon}>{icon}</div>}
        <div className={styles.ClearableInput__content}>{children}</div>
        {hasValue && (
            <a className={styles.ClearableInput__clear} onClick={onClear}>
                <i className={cx('fa', clearIcon)} />
            </a>
        )}
    </Panel>
);

ClearableInput.displayName = 'ClearableInput';

export default ClearableInput;
